// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__Cl69A","meals-appear":"AvailableMeals_meals-appear__8GD9i"};